import styled from 'styled-components';

const SliderStyle = styled.div`
	--swiperSlideWidth: 80.9%;
	--sliderImageHeight: 60%;
	--smallArrowIconSize: var(--sp4x);
	--slideMarginBottom: var(--sp5x);

	position: relative;

	margin-top: var(--bannerDistance);

	.slider-container {
		margin-bottom: var(--slideMarginBottom);
	}

	.swiper {
		background: var(--gray99);

		.swiper-wrapper {
			.swiper-slide {
				width: var(--swiperSlideWidth);

				.imageCont {
					--proportion: var(--sliderImageHeight);
					width: 100%;
				}
			}
		}
	}

	.crs-cont {
		pointer-events: none;
		position: fixed;
		z-index: 4;
		color: var(--white);
		transform: translate(-50%, -50%);
		mix-blend-mode: difference;
		font-size: var(--sliderArrowIconSize);

		&.reverse {
			transform: translate(-50%, -50%) scale(1) rotateY(180deg);
		}

		&.crs-hide {
			display: none;
		}
		&.dark {
			color: var(--blackRussian);
		}
	}

	.pagAndNavWrap {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;

		i {
			&:before {
				color: var(--blackRussian);
				font-size: var(--smallArrowIconSize);
			}

			cursor: pointer;

			&.disabled {
				pointer-events: none;
				opacity: 0.5;
			}
		}

		.left {
			transform: rotate(180deg);
		}
	}

	.paginationWrap {
		display: flex;
		align-items: center;
		gap: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--swiperSlideWidth: 80.7%;
		--sliderImageHeight: 60%;
		--smallArrowIconSize: var(--sp2x);
		--slideMarginBottom: var(--sp5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--swiperSlideWidth: 80.8%;
		--sliderImageHeight: 60%;
		--smallArrowIconSize: var(--sp2x);
		--slideMarginBottom: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--swiperSlideWidth: 81.1%;
		--sliderImageHeight: 60%;
		--smallArrowIconSize: var(--sp2x);
		--slideMarginBottom: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--swiperSlideWidth: 81.8%;
		--sliderImageHeight: 60%;
		--smallArrowIconSize: var(--sp2x);
		--slideMarginBottom: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--swiperSlideWidth: 81.3%;
		--sliderImageHeight: 60%;
		--smallArrowIconSize: var(--sp2x);
		--slideMarginBottom: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--swiperSlideWidth: 80.4%;
		--sliderImageHeight: 60%;
		--smallArrowIconSize: var(--sp2x);
		--slideMarginBottom: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--swiperSlideWidth: 79.8%;
		--sliderImageHeight: 60%;
		--smallArrowIconSize: var(--sp2x);
		--slideMarginBottom: var(--sp2x);
	}
`;

export default SliderStyle;
